import axios from "axios";

import { usePopupStore } from "@/store/common/usePopupStore";
import { useAuthStore } from "@/store/console/useAuthStore";

const consoleAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

let activeRequests = 0;

// 요청 인터셉터
consoleAxios.interceptors.request.use(
    config => {
        activeRequests++;

        // headers 에 토큰 추가
        const { accessToken, clearUser } = useAuthStore.getState();
        if (accessToken) {
            config.headers["Authorization"] = `Bearer ${accessToken}`;
        } else {
            // 토큰 없을경우 로그아웃 처리후 로그인페이지로 이동
            clearUser();
            window.location.href = "/console/login";
        }

        return config; // 수정된 config 반환
    },
    error => {
        activeRequests = Math.max(activeRequests - 1, 0);

        return Promise.reject(error);
    },
);

// 응답 인터셉터
consoleAxios.interceptors.response.use(
    response => {
        activeRequests = Math.max(activeRequests - 1, 0);

        return response; // 성공적으로 응답이 오면 그대로 반환
    },
    error => {
        activeRequests = Math.max(activeRequests - 1, 0);
        const { setConfirmPop } = usePopupStore.getState();
        const { clearUser } = useAuthStore.getState();

        // 토큰 에러시 로그아웃 처리후 로그인페이지로 이동
        if (error.response && error.response.status === 401) {
            clearUser();
            window.location.href = "/console/login";

            //추가 API 요청 방지
            return Promise.reject(new Error("로그아웃됨"));
        }

        // 공통적으로 알림 팝업 표시
        const { status, data } = error.response || {};
        const errorMessage = data?.message || "알 수 없는 에러가 발생했습니다.";

        if (status === 500) {
            setConfirmPop(true, "서버 오류가 발생했습니다.", 1);
        } else {
            setConfirmPop(true, errorMessage, 1);
        }

        return Promise.reject(error); // 개별 호출에서도 에러 처리 가능하도록 전달
    },
);

export default consoleAxios;
